import { IntegrationConnectionTypes } from './integrationConnectionHandler';
import { IntegrationTypes } from './integrationTypeHandler';

export enum IntegrationConnectionDisplayStates {
  NotTested = 0,
  NeedsAttention = 1,
  Authorized = 2,
}

//The tenant's authorization for one connection type, shared by every integration whose type uses it. Created and
//removed by the API together with the integrations; the web saves its credential and tests it.
export class IntegrationConnection {
  integrationConnectionId: number;

  integrationConnectionTypeId: IntegrationConnectionTypes;

  authData: unknown;

  config: unknown;

  isAuthorized: boolean | undefined; //undefined = never tested

  lastVerified?: Date;

  lastError?: string;

  created: Date;

  modified?: Date;

  integrationTypeIds: IntegrationTypes[]; //only filled by the connection endpoints, empty when nested

  constructor() {
    this.integrationConnectionId = 0;
    this.integrationConnectionTypeId = IntegrationConnectionTypes.None;
    this.authData = undefined;
    this.config = undefined;
    this.isAuthorized = undefined;
    this.created = new Date();
    this.integrationTypeIds = [];
  }

  getDisplayState(): IntegrationConnectionDisplayStates {
    if (this.isAuthorized === true) return IntegrationConnectionDisplayStates.Authorized;
    if (this.isAuthorized === false) return IntegrationConnectionDisplayStates.NeedsAttention;

    return IntegrationConnectionDisplayStates.NotTested;
  }

  clone(): IntegrationConnection {
    const clone = new IntegrationConnection();
    clone.integrationConnectionId = this.integrationConnectionId;
    clone.integrationConnectionTypeId = this.integrationConnectionTypeId;
    clone.authData = this.authData ? { ...(this.authData as object) } : undefined;
    clone.config = this.config ? { ...(this.config as object) } : undefined;
    clone.isAuthorized = this.isAuthorized;
    clone.lastVerified = this.lastVerified;
    clone.lastError = this.lastError;
    clone.created = this.created;
    clone.modified = this.modified;
    clone.integrationTypeIds = [...this.integrationTypeIds];

    return clone;
  }
}
